export default {
  pluralization: {
    ticket: 'нет билетов | {n} билет | {n} билета | {n} билетов',
    minute: '0 минут | {n} минута | {n} минуты | {n} минут',
  },
  pending: {
    order: 'Бронируем билеты, пожалуйста, подождите ...',
    operation: 'Операция выполняется, пожалуйста, подождите ...',
    hardware: 'Проверка оборудования, пожалуйста, подождите ...',
    fetch: 'Загружаем данные, пожалуйста, подождите ...',
    pay: 'Идет обработка платежа, пожалуйста, подождите...',
    print: 'Идет печать, пожалуйста, подождите...',
    processing: 'Идет обработка, пожалуйста, подождите...',
  },
  fields: {
    search: 'Введите название спектакля ...',
    fullname: 'ФИО',
    phoneNumber: 'Номер телефона',
    password: 'Пароль администратора',
    ticketAmount: 'Сумма билета',
    orderLink: 'Номер ссылки',
    email: 'Email',
    rate: 'Оценка',
    ticket: 'Билет',
    spectacle: 'Спектакль',
    time: 'Введите время спектакля ...',
    date: 'Введите дату спектакля ...',
    nameLabel: 'Название',
    dateLabel: 'Дата',
    timeLabel: 'Время',
    badEmail: 'Введите E-mail',
    badPhone: 'Введите номер телефона',
    badFullname: 'Введите ФИО',
    badPassword: 'Введите пароль',
    badSum: 'Введите сумму',
    badOrderLink: 'Введите номер ссылки',
    wrongPassword: 'Неверный пароль',
  },
  titles: {
    pay: 'Оплата',
    form: 'Ввод данных',
    cart: 'Корзина',
    events: 'Афиша',
    thanks: 'Спасибо!',
    error: 'Ошибка',
    contacts: 'Оставьте свои контактные данные',
    badConnection: 'Ошибка соединения',
    badHardware: 'Ошибка оборудования',
    whichSpectacle: 'О каком спектакле вы хотите оставить отзыв?',
    notfound: 'Ничего не найдено :(',
    chooseSeat: 'Выбор места',
    email: 'Введите E-mail',
    success: 'Готово!',
    feedback: 'Оставить отзыв',
    aboutSpectacle: 'О спектакле',
    aboutTheatre: 'О театре',
    audioFeedback: 'Аудио отзыв',
    videoFeedback: 'Видео отзыв',
    confirmAbortRecording: 'Вы уверены, что хотите прервать запись отзыва?',
    confirmVideoRecording: 'Хотите записать видео-отзыв?',
    confirmVideoWatching: 'Вы можете просмотреть видео с вашим отзывом',
    confirmClearCart: 'Вы уверены, что хотите очистить корзину?',
    recordIsStarted: 'Идет запись, говорите',
    recordIsFinish: 'Запись завершена!',
    audioRecord: 'Aудио запись',
    orderPaid: 'Заказ оплачен!',
    emptyCart: 'Ваша корзина пуста',
    rateEvent: 'Оцените спектакль',
    bad: 'Плохо',
    fine: 'Нормально',
    great: 'Великолепно',
    fullHall: 'Нет мест',
    yourPhoto: 'Ваше фото',
    yourTickets: 'Ваши билеты',
    spectacleFeedbackWasLeaved: 'Был оставлен отзыв о спектакле',
    theatreFeedbackWasLeaved: 'Был оставлен отзыв о театре',
    admin: 'Сервисное меню',
    refund: 'Вернуть билет',
    spectacleInfo: 'Описание спектакля',
    somethingWrong: 'Что-то пошло не так',
    paperOut: 'Закончилась бумага',
    refundComplete: 'Возврат выполнен',
    refundOrder: 'Отмена заказа #{id}',
  },
  texts: {
    thanksForFeedback: 'Ваш отзыв важен для нас, вы помогаете делать работу театра лучше',
    feedbackNotPossible: 'Нет возможности оставить отзыв',
    payNotPossible: 'Устройство временно недоступно, вы можете приобрести билеты в кассе',
    buyNotPossible: 'Вы можете приобрести билеты в кассе',
    terminalNotWork: 'Устройство временно недоступно, вы можете повторить попытку или приобрести билеты в кассе',
    confirmPayNotPossible: 'Не удалось выполнить обработку платежа, пожалуйста, обратитесь к администратору',
    confirmPayFailed: 'Не удалось выполнить обработку платежа, пожалуйста, повторите попытку или обратитесь к администратору',
    refundFailed: 'Не удалось выполнить возврат платежа, пожалуйста, повторите попытку',
    orderFailed: 'Не удалось забронировать места, вы можете приобрести билеты в кассе',
    photoNotPossible: 'По техническим причинам сделать снимок нельзя',
    videoNotPossible: 'По техническим причинам записать видео нельзя',
    sendPhotoNotPossible: 'По техническим причинам отправить снимок нельзя',
    sendTicketsNotPossible: 'По техническим причинам отправить билеты нельзя',
    tapScreen: 'Коснитесь экрана, чтобы начать',
    videoLabel: 'Нажмите, чтобы ознакомиться с видео-инструкцией',
    photoWasSended: 'Фото отправлено на адрес электронной почты {email}',
    ticketWasSended: 'Билет отправлен на адрес электронной почты {email}',
    audioInstruction: 'Чтобы оставить аудиоотзыв нажмите «начать»',
    videoInstruction: 'Чтобы оставить видеоотзыв нажмите «начать»',
    payInstruction: 'Произведите оплату, следуя указаниям на пин-паде...',
    startRecording: 'Нажмите кнопку, чтобы начать запись',
    playRecording: 'Вы можете прослушать аудиоотзыв',
    termsRefund: 'ознакомлены с правилами продажи и возврата билетов',
    termsPersonal: 'согласие на обработку персональных данных',
    termsFull: 'Нажимая на кнопку Оплатить вы подтверждаете, что {0} и даете {1} с целью выполнения данного заказа',
    refund: 'Правила продажи и возврата билетов',
    paySum: 'Итого к оплате:',
    sum: 'сумма:',
    rowNumber: 'Ряд {0}',
    seatNumber: 'Место {0}',
    author: 'Автор',
    noSeats: 'К сожалению, свободных мест на это мероприятие уже не осталось ...',
    operationComplete: 'Операция успешно завершена',
    recommendedAge: 'Рекомендуется к просмотру от {age}',
    noDescription: 'Описание отсутствует',
    pleaseTryAgain: 'Пожалуйста, попробуйте еще раз',
    pleaseContactAdmin: 'Пожалуйста, обратитесь к администратору',
    notfound: 'К сожалению, на ваш поисковый запрос ничего не найдено',
    refundDescription: 'Для возврата следуйте указаниям на пин-паде...',
    feedbackActionNote: 'Спектакль выбран, произнесите «Оставить отзыв» или «Описание спектакля»',
    buyActionNote: 'Спектакль выбран, произнесите «Купить билет» или «Описание спектакля»',
    searchNameNote: 'Для поиска нужного спектакля произнесите «Найти» и название нужного спектакля',
    searchDateNote: 'Для поиска нужного спектакля произнесите «Найти» и дату нужного спектакля',
    searchTimeNote: 'Для выбора нужного спектакля произнесите «Найти» и время нужного спектакля',
    cancelOrderFailed: 'При операции отмены билетов произошла ошибка',
    soldOut: 'Все билеты уже проданы, пожалуйста, выберите другое время или день',
  },
  actions: {
    all: 'Все',
    pay: 'Оплатить',
    done: 'Готово',
    cart: 'В корзину',
    home: 'На главную',
    send: 'Отправить',
    view: 'Просмотреть',
    pick: 'Выбрать',
    dance: 'Веселый танец',
    start: 'Начать',
    abort: 'Прервать',
    cancel: 'Отмена',
    finish: 'Завершить',
    confirm: 'Подтвердить',
    print: 'Распечатать',
    retry: 'Повторить',
    listen: 'Прослушать',
    reshoot: 'Переснять',
    rewrite: 'Перезаписать',
    continue: 'Продолжить',
    highFive: 'Дай пять',
    understand: 'Понятно',
    sendToEmail: 'Отправить на email',
    sendToAnotherEmail: 'Отправить на другой email',
    buyTicket: 'Купить билет',
    addFeedback: 'Оставить отзыв',
    addAnotherFeedback: 'Оставить еще один отзыв',
    takeMyPhoto: 'Сфотографируй меня',
    takePhoto: 'Сфотографировать',
    photo: 'Хочу селфи!',
    showEntertainment: 'Развлечения для детей',
    tellStory: 'Расскажи сказку',
    shakeHand: 'Пожать руку',
    showPlane: 'Покажи самолет',
    tellRiddle: 'Загадай загадку',
    yesAbort: 'Да, прервать',
    noContinue: 'Нет, продолжить',
    sendFeedback: 'Отправить отзыв',
    termsLink: 'Даю согласие на обработку персональных данных',
    yesRecordVideo: 'Да, записать видео',
    noSkipVideo: 'Нет, продолжить без видео',
    skipVideo: 'Продолжить без видео',
    placeOrder: 'Оформить заказ',
    chooseSeat: 'Выбрать место',
    clearCart: 'Очистить корзину',
    yes: 'Да',
    no: 'Нет',
    anotherPick: 'Выбрать другое',
    secondDance: 'Быстрый танец',
    noTickets: 'Билеты проданы',
    showSpectacleInfo: 'Описание спектакля',
    selectFrame: 'Выбрать рамку',
    removeFrame: 'Удалить рамку',
    openSession: 'Открыть смену',
    closeSession: 'Закрыть смену',
    refundTicket: 'Вернуть билет',
    backToMenu: 'Назад в меню',
    makeRefund: 'Сделать возврат',
    toEventsList: 'К списку спектаклей',
    tryAgain: 'Попробовать еще',
  },
};
